import { getNumberString } from './getNumberString'

export const createDate = (date: Date) => {
  const months = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec'
  ]
  const diffDays = new Date().getDate() - date.getDate(),
    diffMonths = new Date().getMonth() - date.getMonth(),
    diffYears = new Date().getFullYear() - date.getFullYear()
  if (diffYears === 0 && diffMonths === 0 && diffDays === 0) {
    return 'Today'
  } else if (diffYears === 0 && diffMonths === 0 && diffDays === 1) {
    return 'Yesterday'
  } else if (diffYears >= 1) {
    return (
      months[date.getMonth()] + ' ' + getNumberString(date.getDate()) + ', ' + date.getFullYear()
    )
  } else {
    return months[date.getMonth()] + ' ' + getNumberString(date.getDate())
  }
}
